{
  "COOKIE_CONSENT": {
    "MESSAGE": "אתר זה משתמש בקובצי עוגיות על מנת לשפר את חווית הגלישה שלך. על ידי לחיצה על \"אישור\", הנך מסכים לשימוש בקובצי עוגיות. ",
    "PRIVACY_LINK": "למדיניות הפרטיות לחץ כאן",
    "ACCEPT": "אישור"
  },
  "TOP_CATALOG": {
    "UNAVAILABLE_TITLE": "קטלוג היצרן אינו זמין כרגע",
    "UNAVAILABLE_DESC": "השירות אינו פעיל בסביבה זו או שפג תוקף המנוי. אנא פנה לתמיכה."
  },
  "COMMON": {
    "LOADING": "טוען...",
    "ERROR": "שגיאה",
    "SAVE": "שמור",
    "CANCEL": "ביטול",
    "CONFIRM": "אישור",
    "DELETE": "מחק",
    "EDIT": "ערוך",
    "CLOSE": "סגור",
    "SEARCH": "חיפוש",
    "FIND_PART": "מצא חלק",
    "ADD_TO_CART": "הוסף לסל",
    "IN_STOCK": "במלאי",
    "OUT_OF_STOCK": "אזל מהמלאי",
    "LIMITED_STOCK": "מלאי מוגבל",
    "VAT_INCLUDED": "כולל מע\"מ",
    "NET_PRICE": "מחיר נטו",
    "BRUTTO_PRICE": "ברוטו לפני מע\"מ",
    "RECOMMENDED_PRICE": "מחיר מומלץ לצרכן"
  },
  "NAV": {
    "CATALOG": "קטלוג",
    "ABOUT": "אודות",
    "NEWS": "חדשות",
    "SIGN_IN": "כניסה",
    "PROFILE": "פרופיל",
    "LOGOUT": "יציאה",
    "HOME": "ראשי",
    "TOP_CATALOG": "Top Catalog",
    "TERMS": "תקנון שימוש",
    "PRIVACY": "מדיניות פרטיות"
  },
  "SEARCH": {
    "PLATE_NUMBER": "מספר לוחית רישוי",
    "SELECT_MANUFACTURER": "בחר יצרן",
    "SELECT_MODEL": "בחר דגם",
    "ARTICLE_NUMBER": "מספר חלק",
    "CATALOG_TYPE_TITLE": "בחר סוג קטלוג",
    "OUR_CATALOG": "הקטלוג שלנו",
    "TOP_CATALOG": "Top Catalog",
    "SELECT_SUBMODEL": "בחר דגם משנה",
    "PLATE_NO_RESULTS": "לא נמצא רכב עבור לוחית הרישוי",
    "ARTICLE_NO_RESULTS": "לא נמצאו תוצאות עבור המספר שהוזן",
    "PLATE_RESULTS": "בחר את הרכב שלך",
    "LIMITED_STOCK": "מלאי מוגבל",
    "OR": "או",
    "SEARCH_BY_MODEL": "חיפוש לפי יצרן ודגם",
    "HIDE_MODEL_SEARCH": "הסתר חיפוש לפי דגם"
  },
  "AUTH": {
    "LOGIN": "כניסה",
    "REGISTER": "הרשמה",
    "EMAIL": "אימייל",
    "EMAIL_PLACEHOLDER": "your@email.com",
    "PASSWORD": "סיסמה",
    "PASSWORD_PLACEHOLDER": "לפחות 7 תווים",
    "FORGOT_PASSWORD": "שכחתי סיסמה",
    "RESET_PASSWORD": "איפוס סיסמה",
    "FULL_NAME": "שם מלא",
    "PHONE": "טלפון",
    "COMPANY_NAME": "שם חברה",
    "DEALER_NUMBER": "מספר עוסק",
    "ADDRESS": "כתובת",
    "LOGIN_TITLE": "כניסה לחשבון",
    "LOGIN_BTN": "כניסה",
    "FORGOT_TITLE": "שכחתי סיסמה",
    "FORGOT_DESC": "הזן את כתובת האימייל שלך ונשלח לך קישור לאיפוס סיסמה",
    "FORGOT_SEND": "שלח קישור",
    "FORGOT_SUCCESS": "הקישור לאיפוס נשלח לכתובת",
    "BACK_TO_LOGIN": "חזרה לכניסה",
    "RESET_TITLE": "קביעת סיסמה חדשה",
    "NEW_PASSWORD": "סיסמה חדשה",
    "CONFIRM_PASSWORD": "אישור סיסמה",
    "RESET_BTN": "שמור סיסמה",
    "RESET_LINK_INVALID": "הקישור לא תקף או פג תוקפו",
    "REQUEST_NEW_LINK": "בקש קישור חדש",
    "RESET_SUCCESS": "הסיסמה שונתה בהצלחה!",
    "CONFIRMING_EMAIL": "מאמת כתובת אימייל...",
    "EMAIL_CONFIRMED": "האימייל אומת בהצלחה!",
    "EMAIL_CONFIRM_ERROR": "אימות האימייל נכשל. הקישור לא תקף.",
    "VALIDATING": "מאמת קישור..."
  },
  "PROFILE": {
    "TITLE": "החשבון שלי",
    "EDIT_TITLE": "עריכת פרטים",
    "PASSWORD_TITLE": "שינוי סיסמה",
    "HISTORY_TITLE": "היסטוריית הזמנות",
    "LOGOUT": "יציאה",
    "FULL_NAME": "שם מלא",
    "PHONE": "טלפון",
    "ADDRESS": "כתובת",
    "SAVE": "שמור שינויים",
    "OLD_PASSWORD": "סיסמה נוכחית",
    "NEW_PASSWORD": "סיסמה חדשה",
    "CONFIRM_NEW_PASSWORD": "אישור סיסמה חדשה",
    "NO_ORDERS": "אין הזמנות עדיין",
    "ORDER_ID": "מספר הזמנה",
    "ORDER_DATE": "תאריך",
    "ORDER_STATUS": "סטטוס",
    "ORDER_TOTAL": "סכום",
    "VIEW_ORDER": "צפה",
    "NET_TOTAL": "סכום נטו",
    "GROSS_TOTAL": "סכום ברוטו",
    "COMMENTS": "הערות",
    "QUANTITY": "כמות",
    "REORDER": "חזור על ההזמנה"
  },
  "HOME": {
    "HERO_TITLE": "מצא חלקי רכב במהירות",
    "HERO_SUBTITLE": "חפש לפי מספר לוחית רישוי, יצרן או מספר חלק",
    "CATEGORIES_TITLE": "קטלוג חלקים",
    "CATEGORIES_SUBTITLE": "גלה את המלאי המקיף שלנו לפי קטגוריית מערכת.",
    "CATEGORIES_VIEW_ALL": "כל הקטגוריות",
    "CATEGORIES_SEARCH": "חפש קטגוריה או חלק...",
    "BRANDS_TITLE": "מותגים מובילים",
    "BEST_SELLERS_TITLE": "הנמכרים ביותר",
    "POPULAR_TITLE": "חלקים פופולריים",
    "POPULAR_SKU_LABEL": "מק״ט",
    "NEWS_TITLE": "חדשות",
    "VIEW_ALL": "הכל",
    "BEST_SELLER": "מוצר מוביל",
    "HERO_FEATURE_IMPORT": "יבוא עולמי",
    "HERO_FEATURE_QUALITY": "מלאי רחב",
    "HERO_FEATURE_DELIVERY": "הובלה מהירה",
    "ADVANTAGES_IMPORT_DESC": "מקורות אספקה ממדינות מובילות בעולם",
    "ADVANTAGES_QUALITY_DESC": "מגוון עצום של חלקים לכל סוגי הרכבים",
    "ADVANTAGES_DELIVERY_DESC": "זמינות גבוהה ומשלוחים מהירים לכל רחבי הארץ",
    "CAT_BRAKES": "מערכת בלימה",
    "CAT_FILTERS": "פילטרים",
    "CAT_CHASSIS": "חלקי שלדה והיגוי",
    "CAT_ENGINE": "חלקי מנוע",
    "CAT_ELECTRICAL": "חשמל ומיזוג אוויר",
    "CAT_LIGHTING": "תאורה ומרכב"
  },
  "NAV_EXTRA": {
    "HOME": "ראשי"
  },
  "CATALOG": {
    "FILTERS": "סינון",
    "CLEAR_ALL": "נקה הכל",
    "APPLY": "החל",
    "PRICE_RANGE": "טווח מחירים",
    "BRAND": "יצרן",
    "IN_STOCK": "במלאי בלבד",
    "NO_RESULTS": "לא נמצאו תוצאות",
    "NO_RESULTS_HINT": "נסה לשנות את הסינון או לחפש משהו אחר",
    "POSITION": "מיקום",
    "NO_CATEGORIES": "לא נמצאו קטגוריות",
    "CATEGORIES": "קטגוריות",
    "SEARCH_CATEGORIES": "חיפוש קטגוריה...",
    "TOP_CATALOG": "קטלוג יצרן",
    "TOP_CATEGORIES": "קטגוריות פופולריות",
    "SUBCATEGORIES": "תת-קטגוריות",
    "NO_ARTICLES": "לא נמצאו פריטים",
    "SHOWING": "מציג",
    "RESULTS": "תוצאות",
    "FOR": "עבור"
  },
  "PRODUCT": {
    "ARTICLE_NUMBER": "מספר חלק",
    "BRAND": "יצרן",
    "IN_STOCK": "במלאי",
    "LIMITED_STOCK": "מלאי מוגבל",
    "OUT_OF_STOCK": "אזל מהמלאי",
    "CHARACTERISTICS": "מפרט טכני",
    "NO_CHARACTERISTICS": "אין מפרט זמין",
    "OEM_REFERENCES": "מספרי OEM",
    "NO_OEMS": "אין מספרי OEM זמינים",
    "COMPATIBLE_CARS": "תאימות רכב",
    "NO_COMPATIBLE_CARS": "אין נתוני תאימות",
    "NOT_FOUND": "המוצר לא נמצא"
  },
  "CONTACT": {
    "TITLE": "זקוקים לחלק מסוים?",
    "SUBTITLE": "אנחנו כאן כדי לעזור!",
    "NAME": "שם מלא",
    "PHONE": "טלפון",
    "EMAIL": "אימייל",
    "MESSAGE": "הודעה",
    "SEND": "שלח",
    "SENT": "ההודעה נשלחה! נחזור אליכם בקרוב.",
    "SERVICE": "שירות מקצועי",
    "CONSULTING": "ייעוץ והתאמה",
    "PRICING": "מחירים תחרותיים"
  },
  "ADMIN": {
    "SWITCH_CUSTOMER": "החלף לקוח",
    "MY_ACCOUNT": "החשבון שלי",
    "SEARCH_CUSTOMER": "חיפוש לקוח...",
    "ACTING_AS": "פועל בשם",
    "CUSTOMERS_TITLE": "בחר לקוח",
    "RETURN_TO_ADMIN": "חזרה לחשבון שלי"
  },
  "CART": {
    "TITLE": "סל קניות",
    "EMPTY": "הסל ריק",
    "SUBTOTAL": "סכום ביניים",
    "VAT": "מע\"מ",
    "TOTAL": "סה\"כ",
    "ITEMS_COUNT": "מספר פריטים",
    "DELIVERY_METHOD": "שיטת משלוח",
    "SELECT_DELIVERY": "בחר שיטת משלוח",
    "DELIVERY_ADDRESS": "כתובת למשלוח",
    "COMMENT": "הערה",
    "CONFIRM_ORDER": "אשר הזמנה",
    "ORDER_DETAILS": "פרטי הזמנה",
    "PAYMENT_LINK_SENT": "לינק לתשלום נשלח לאימייל שלך",
    "SUCCESS_TITLE": "הזמנתך התקבלה!",
    "SUCCESS_DESC": "נציג יצור איתך קשר בהקדם",
    "PROMO_PRICE": "מחיר מבצע",
    "REGULAR_PRICE": "מחיר רגיל",
    "PROMO_HINT": "הוסף {{ moq }} יחידות ומעלה לקבלת מחיר מבצע ₪{{ price }}"
  }
}